import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import NotAvailableImage from './assets/not-available.png';
import { Button, Typography } from '@material-ui/core';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const styles = theme => ({
	container: {
		textAlign: 'center'
	},
	image: {
		height: 'auto',
		width: 300,
		marginTop: 40,
		marginBottom: 10
	},
	errorMessage: {
		fontSize: 16,
		lineHeight: 1.5,
		marginBottom: 30
	}
});

@withStyles(styles)
class PageNotAvailable extends Component {

	render() {
		const { classes } = this.props;
		return (
			<div className={classes.container}>
				<img
					className={classes.image}
					src={NotAvailableImage}
					alt={localize('page-not-available-image-alt')} />
				<Typography variant='body2' className={classes.errorMessage}>
					{localize('page-not-available-message')}
				</Typography>
				<Button
					data-tid={'button-page-not-available-refresh'}
					variant='contained'
					color='primary'					
					onClick={() => {
						window.location = '/?reload-app=true';
					}}					
				>
					{localize('page-not-available-refresh')}
				</Button>
			</div>
		);
	}

}

PageNotAvailable.propTypes = {
	classes: PropTypes.object,
	selectedCompanyId: PropTypes.string,
};

const mapStateToProps = state => ({
	selectedCompanyId: state.companies.selectedId,
});


export default connect(
	mapStateToProps
)(PageNotAvailable);


// WEBPACK FOOTER //
// ./src/containers/PageNotAvailable/PageNotAvailable.js